<button climbButton size="md" variant="ghost" (click)="openMessageCenter()">
    <svg [climbIcon]="icons.bellFilled" size="sm"></svg>
</button>

<div *ngIf="messageCount > 0" class="message-count">
    {{messageCount > 99 ? '99+' : messageCount}}
</div>
